// Shared in-app PDF preview dialog (immune to browser popup blockers).
import React from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ExternalLink } from "lucide-react";

export default function PdfPreviewDialog({ url, title = "Preview", onClose }) {
  return (
    <Dialog open={!!url} onOpenChange={v => { if (!v) onClose?.(); }}>
      <DialogContent className="max-w-5xl h-[88vh] flex flex-col" data-testid="pdf-preview-dialog">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: "'Anek Malayalam', sans-serif" }}>{title}</DialogTitle>
        </DialogHeader>
        {url && (
          <iframe src={url} title={title} className="flex-1 w-full rounded-md border border-border bg-muted/30" data-testid="pdf-preview-frame" />
        )}
        <div className="flex justify-end gap-2 pt-2">
          {url && (
            <a href={url} target="_blank" rel="noreferrer" data-testid="pdf-preview-newtab">
              <Button variant="outline" size="sm"><ExternalLink className="w-4 h-4 mr-1.5" /> Open in New Tab</Button>
            </a>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
